import {
    type SketchGroup,
} from '../../../mesh/sketch';
import {
    buildRuntimeSketchEntitiesFromGroup,
    buildRuntimeSketchPlaneFromGroup,
} from '../../../utils/feature';

/**
 * 旋转草图运行时输入序列化器。
 *
 * 文件定位：
 * 1. 位于 Viewer 的 revolve-region 模块，负责把当前场景草图对象转成 Worker 可克隆纯数据；
 * 2. 不保存选择状态，不触发几何计算；
 * 3. 避免把 THREE/Vue 响应式对象传入 cad-core worker。
 */
export class RevolveSketchRuntimeInputSerializer {
    /**
     * 构建草图区域解析载荷。
     * @param sketchGroup 草图组。
     * @returns Worker 载荷；草图没有可用实体时返回 null。
     */
    public buildFindRegionsPayload(sketchGroup: SketchGroup): FindSketchRegionsPayload | null {
        const entities = buildRuntimeSketchEntitiesFromGroup(sketchGroup);
        if (entities.length <= 0) {
            return null;
        }
        return {
            sketchId: sketchGroup.uuid,
            entities,
            plane: buildRuntimeSketchPlaneFromGroup(sketchGroup),
        };
    }
}
